module.exports = __webpack_public_path__ + "static/media/AF.196a5bee.png";